import { render } from "./CompanyBillingClosingModal.vue?vue&type=template&id=5959f48e"
import script from "./CompanyBillingClosingModal.vue?vue&type=script&lang=js"
export * from "./CompanyBillingClosingModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__